import React, { useState } from "react";
import { Grid, Typography, Box, useTheme, useMediaQuery, LinearProgress } from "@material-ui/core";
import SelfInspectionList from "../../../../components/SelfInspectionList/SelfInspectionList.component";
import { useSelfInspectionDataContext } from "../../../../context/SelfInspection/selfInspection.provider";
import { useInfiniteQuery } from "react-query";
import {
  selfInspectionsQuery,
  SELF_INSPECTIONS_QUERY,
} from "../../../../query/selfInspections/selfInspections";
import InfiniteScroll from "react-infinite-scroll-component";

const ChooseInspection = () => {
  const { setSelectedInspection, nextStep } = useSelfInspectionDataContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const [page, setPage] = useState(1);
  const [,setFilterPage] = useState(1);
  const [query, setQuery] = useState(null);
  let filteredPage = []
  let lastPageEmpty = 0;

  const handleNextStep = (inspection: any) => {
    setSelectedInspection(inspection);
    nextStep();
  };
  // infinity here?
  const {
    data: selfInspections,
    fetchNextPage,
  } = useInfiniteQuery(
    SELF_INSPECTIONS_QUERY,
    selfInspectionsQuery,
    {
      getNextPageParam: (lastPage) => {
        filteredPage = lastPage;
        lastPageEmpty = lastPage.length;
      },
    }
  );

  const handleNextPage = () => {
    fetchNextPage({ pageParam: page + 1 });
    setPage((prev) => prev + 1);
  };

  const handleFilter = (query: any) => {
    setQuery(query);
    fetchNextPage({ pageParam: query });
    setFilterPage((prev) => prev + 1);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box my={3}>
            <Typography variant="h6" color="primary">
              Uno o más vehículos necesita una autoinspección
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={11}>
              {
                matches ?
                  <div id="scrollableDiv"
                    style={{
                      height: 600,
                      overflow: 'auto',
                    }}
                  >
                    <InfiniteScroll
                      //This is important field to render the next data
                      dataLength={selfInspections?.pages?.flat().length}
                      next={handleNextPage}
                      hasMore={lastPageEmpty > 0 && lastPageEmpty > 19  ? true : false}
                      loader={
                        <Box style={{ width: '100%' }}>
                          <LinearProgress color="primary" />
                        </Box>
                      }
                      endMessage={
                        <Box m={2}>
                          <Typography
                            style={{ textAlign: 'center' }}
                            color="textSecondary"
                          >
                            Ya hemos mostrado todos los resultados
                          </Typography>
                        </Box>
                      }
                      scrollableTarget={"scrollableDiv"}
                    >
                      <SelfInspectionList
                        handleFilter={handleFilter}
                        setFunction={handleNextStep}
                        selfInspections={!query ? selfInspections?.pages?.flat() : filteredPage}
                        verified
                      ></SelfInspectionList>
                    </InfiniteScroll>
                  </div>
                  :
                  <InfiniteScroll
                    //This is important field to render the next data
                    dataLength={selfInspections?.pages?.flat().length}
                    next={handleNextPage}
                    hasMore={lastPageEmpty > 0 && lastPageEmpty > 19  ? true : false}
                    loader={
                      <Box style={{ width: '100%' }}>
                        <LinearProgress color="primary" />
                      </Box>
                    }
                    endMessage={
                      <Box m={2}>
                        <Typography
                          style={{ textAlign: 'center' }}
                          color="textSecondary"
                        >
                          Ya hemos mostrado todos los resultados
                        </Typography>
                      </Box>
                    }
                  >
                    <SelfInspectionList
                      handleFilter={handleFilter}
                      setFunction={handleNextStep}
                      selfInspections={!query ? selfInspections?.pages?.flat() : filteredPage}
                      verified
                    ></SelfInspectionList>
                  </InfiniteScroll>
              }
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ChooseInspection;
